module.exports = __webpack_public_path__ + "img/金吉利.9c96b3d3.svg";